import i18next from '@packages/core/i18n';

import eventLogs from './en/eventLogs.json';
import eventLogSearch from './en/eventLogSearch.json';
import flow from './en/flow.json';
import logSearch from './en/logSearch.json';
import logSearchHistory from './en/logSearchHistory.json';
import logSearchResults from './en/logSearchResults.json';
import logSearchSources from './en/logSearchSources.json';
import rawLogDownload from './en/rawLogDownload.json';
import whatsNew from './en/whats-new.json';

i18next.addResourceBundle('en', 'eventLogs', eventLogs);
i18next.addResourceBundle('en', 'eventLogSearch', eventLogSearch);
i18next.addResourceBundle('en', 'flow', flow);
i18next.addResourceBundle('en', 'logSearch', logSearch);
i18next.addResourceBundle('en', 'logSearchHistory', logSearchHistory);
i18next.addResourceBundle('en', 'logSearchResults', logSearchResults);
i18next.addResourceBundle('en', 'logSearchSources', logSearchSources);
i18next.addResourceBundle('en', 'rawLogDownload', rawLogDownload);
i18next.addResourceBundle('en', 'data-explorer', { whatsNew });

export default i18next;
